import React from 'react';

/**
 * TileLoadingSpinner — the per-cell "loading" affordance for a live video tile.
 *
 * Shown while a tile connects + paints its first frame, on BOTH live paths:
 *   - cloud (WS-only, VideoViewWs) — over the black tile until the first WS frame, and
 *   - eview/dview (JPEG base + WS overlay, CameraStreamContainer) — until the first JPEG loads.
 * Previously only the cloud path had it, so switching a camera on eview/dview showed a bare
 * placeholder with no loading cue (David 2026-08-15).
 *
 * Centered white spinner over the tile, no scrim — reads as a light "loading", cleared on the
 * first frame. Styling (+ the shared `spin` keyframe) lives in liveStyle.css.
 */
const TileLoadingSpinner = () => (
  <div className="live-tile-loading"><div className="live-tile-spinner" /></div>
);

export default TileLoadingSpinner;
